import { useToast as useToastComposable, TYPE } from 'vue-toastification'
import Toast from 'vue-toastification'
import { useTheme, useDisplay } from 'vuetify'
import 'vue-toastification/dist/index.css'
import '../scss/toast/index.scss'

export default Toast
export const defaultOptions = {
  closeOnClick: false,
  timeout: 3000,
  position: 'top-right',
  toastClassName: 'e-toast',
  bodyClassName: 'e-toast__body',
  containerClassName: 'e-toast-container',
  transition: 'Vue-Toastification__fade',
  hideProgressBar: true,
  icon: 'icon-info',
  closeButtonClassName: 'icon-close-sign',
  draggable: false,
  toastDefaults: {
    [TYPE.SUCCESS]: {
      icon: 'icon-success',
    },
    [TYPE.ERROR]: {
      icon: 'icon-danger',
    },
    [TYPE.INFO]: {
      icon: 'icon-info',
    },
    [TYPE.DEFAULT]: {
      icon: 'icon-info',
    },
    [TYPE.WARNING]: {
      icon: 'icon-exclamation',
    },
  },
}

export function useToast() {
  const theme = useTheme()
  const display = useDisplay()

  const t = useToastComposable()

  const mergeOpts = (options = {}) => {
    return {
      position: display.smAndDown.value ? 'bottom-center' : 'top-right',
      toastClassName: [theme.themeClasses.value, 'e-toast', options.small ? 'e-size--small' : ''],
      ...options,
    }
  }

  const toast = (content, options) => {
    return t(content, mergeOpts(options))
  }
  toast.success = (content, options) => t.success(content, mergeOpts(options))
  toast.info = (content, options) => t.info(content, mergeOpts(options))
  toast.error = (content, options) => t.error(content, mergeOpts(options))
  toast.warning = (content, options) => t.warning(content, mergeOpts(options))
  toast.clear = t.clear
  toast.updateDefaults = t.updateDefaults
  toast.dismiss = t.dismiss
  toast.update = t.update
  return { toast }
}
